module.exports = __webpack_public_path__ + "img/bg-svip.289d5ed6.png";